export default __webpack_public_path__ + "static/media/2205.4c5b8fcd.png";